<template>
  <div class="page-content">
    <top-menu :setUser="setUser" :user="user" :key="user ? `top-menu-${user._id}` : 'top-menu'"></top-menu>

    <el-row type="flex" justify="center" class="page-body peak-page">
      <el-col :xs="{span: 24}" :sm="{span: 24}" class="content-wrapper home-row">
        <background></background>

        <profile-menu-mobile v-if="userToPeak"
                             :user="userToPeak"
                             :changeMode="changeMode"
                             :mode="mode"
                             :layout="'peaking'"
                             :sendFriendRequest="sendFriendRequest"
                             :submitFriendRequest="submitFriendRequest"
        ></profile-menu-mobile>

        <!---------------------------->
        <!-- If user, show profile -->
        <!---------------------------->
        <el-row type="flex" justify="left" v-if="userToPeak">

          <el-col :xs="{span: 6}" :sm="{span: 6}" style="max-width: 220px; border-right-color: #dcdfe6; border-right-style:solid; border-right-width: 1px;" class="hidden-sm-and-down">
            <profile-menu-desktop  :user="userToPeak"
                                   :changeMode="changeMode"
                                   :mode="mode"
                                   :layout="'peaking'"
                                   :sendFriendRequest="sendFriendRequest"
                                   :submitFriendRequest="submitFriendRequest"
                                   :submitting="submitting"
            ></profile-menu-desktop>
          </el-col>

          <!---------------------------->
          <!-- Profile -->
          <!---------------------------->
          <el-col :xs="{span: 23}" :md="{span: 18}" v-if="mode === 'profile'">
            <el-divider class="hidden-xs-only">{{'Profile'}}</el-divider>
            <div style="margin: 20px" class="hidden-sm-and-up"></div>
            <profile :user="userToPeak" :peak="true"></profile>
          </el-col>

          <!---------------------------->
          <!--All games -->
          <!---------------------------->
          <el-col :xs="{span: 23}" :md="{span: 18}" v-if="mode === 'myGames'">
            <el-divider class="hidden-xs-only">{{'All games'}}</el-divider>
            <div style="margin: 20px" class="hidden-sm-and-up"></div>
            <profile-games :user="userToPeak" mode="myGames" :peak="true" :key="'my-games-page'"></profile-games>
          </el-col>

          <!---------------------------->
          <!--Playing games -->
          <!---------------------------->
          <el-col :xs="{span: 23}" :md="{span: 18}" v-if="mode === 'playing'">
            <el-divider class="hidden-xs-only">{{'Playing games'}}</el-divider>
            <div style="margin: 20px" class="hidden-sm-and-up"></div>
            <profile-games :user="userToPeak" mode="playing" :peak="true" :key="'playing-games-page'"></profile-games>
          </el-col>

          <!---------------------------->
          <!--Finished games -->
          <!---------------------------->
          <el-col :xs="{span: 23}" :md="{span: 18}" v-if="mode === 'finished'">
            <el-divider class="hidden-xs-only">{{'Finished games'}}</el-divider>
            <div style="margin: 20px" class="hidden-sm-and-up"></div>
            <profile-games :user="userToPeak" mode="finished" :peak="true" :key="'finished-games-page'"></profile-games>
          </el-col>

          <!---------------------------->
          <!--Played games -->
          <!---------------------------->
          <el-col :xs="{span: 23}" :md="{span: 18}" v-if="mode === 'played'">
            <el-divider class="hidden-xs-only">{{'Played games'}}</el-divider>
            <div style="margin: 20px" class="hidden-sm-and-up"></div>
            <profile-games :user="userToPeak" mode="played" :peak="true" :key="'played-games-page'"></profile-games>
          </el-col>

          <!---------------------------->
          <!--Going2lplay games -->
          <!---------------------------->
          <el-col :xs="{span: 23}" :md="{span: 18}" v-if="mode === 'going2play'">
            <el-divider class="hidden-xs-only">{{'Going to play'}}</el-divider>
            <div style="margin: 20px" class="hidden-sm-and-up"></div>
            <profile-games :user="userToPeak" mode="going2play" :peak="true" :key="'going2play-games-page'" :onEmit="onGameEmit"></profile-games>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <page-footer :key="'footer'"></page-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import TopMenu from '@/components/top-menu.vue'
import PageFooter from '@/components/page-footer.vue'

import Background from '@/components/background.vue'

import Profile from '@/components/profile.vue'
import ProfileMenuMobile from '@/components/profile-menu-mobile.vue'
import ProfileMenuDesktop from '@/components/profile-menu-desktop.vue'
import ProfileGames from '@/components/profile-games.vue'

import ErrorHandling from '@/utils/error-handling.js'

export default {
  name: 'Peak',
  components: {
    TopMenu,
    PageFooter,

    Background,

    Profile,
    ProfileMenuMobile,
    ProfileMenuDesktop,
    ProfileGames
  },
  mounted () {
    // Get user to peak
    this.getUserToPeak()

    // Add socket events
    this.socketEvents()

    // Set mode
    this.setMode()
  },
  data () {
    return {
      user: this.$store.state.user,

      userToPeak: false,
      userToPeakAvatar: false,

      onlineIcon: require(`@/assets/icon-onn.png`),
      offlineIcon: require(`@/assets/icon-off.png`),
      awayIcon: require(`@/assets/icon-away.png`),

      mode: 'profile',

      loading: false,
      submitting: false
    }
  },
  methods: {
    setMode () {
      // If no user, go to login page
      if (!this.user) {
        this.$router.push({ name: 'home', query: { mode: 'login' } })
      }

      // If valid sub mode is given
      if (this.$route.query.mode && ['profile'].includes(this.$route.query.mode)) {
        this.changeMode(this.$route.query.mode)
        return
      }

      // Else go to profile of user to peak
      this.changeMode('profile')
    },

    changeMode (mode) {
      this.mode = mode
      this.$router.replace({ query: { mode: mode } })
    },

    setUser (user) {
      if (user) {
        this.$store.commit('user', user)
        this.user = user
      } else {
        this.$store.commit('user', false)
        this.user = false
        this.$router.push({ name: 'home', query: { mode: 'login' } })
      }
    },
    // ---------------------------------------
    // Socket events
    // ---------------------------------------
    socketEvents () {
      const self = this

      // ---------------------------------------
      // Online/Offline status
      // ---------------------------------------
      this.$socket.on('incomingMember', function (data) {
        if (self.userToPeak._id === data.userId) {
          self.userToPeak.currentStatus = 'online'
        }
      })

      this.$socket.on('leavingMember', function (data) {
        if (self.userToPeak._id === data.userId) {
          self.userToPeak.currentStatus = 'offline'
        }
      })

      // ---------------------------------------
      // Friendship status
      // ---------------------------------------
      this.$socket.on('newFriendRequest', function (data) {
        if (self.userToPeak._id === data.fromUser._id) {
          self.userToPeak.status = 'pending'
        }
      })

      this.$socket.on('acceptFriendRequest', function (data) {
        if (self.userToPeak._id === data.fromUser._id) {
          self.userToPeak.status = 'accepted'
        }
      })

      this.$socket.on('denyFriendRequest', function (data) {
        if (self.userToPeak._id === data.fromUser._id) {
          self.userToPeak.status = 'decline'
        }
      })
    },

    // ---------------------------------------
    // Endpoints 1/2 (Happy flow)
    // ---------------------------------------
    async getUserToPeak () {
      if (this.loading) {
        this.$message.error('Already loading user to peak, please wait!')
        return
      }

      this.loading = true

      const res = await this.$http.get(`friendship/${this.$route.params.id}`)
      if (res.errors && res.errors.length) {
        ErrorHandling(res.errors, 'userToPeak', { handleMessage: this.$message.error })
        this.loading = false
      } else {
        this.loading = false
        this.userToPeak = res.list[0]
        this.userToPeakAvatar = require(`@/assets/${this.userToPeak.avatar || 'avatar1'}.png`)
      }
    },

    async sendFriendRequest () {
      if (this.submitting) {
        this.$message.error('Already submitting friend request, please wait!')
        return
      }

      this.submitting = true

      const res = await this.$http.post(`friendships`, { user: this.userToPeak._id })
      if (res.errors && res.errors.length) {
        ErrorHandling(res.errors, 'submitFriendship', { handleMessage: this.$message.error })
        this.submitting = false
      } else {
        this.submitting = false
        this.$message.success('Friend request send!')
        this.userToPeak.status = 'waiting'
      }
    },

    async submitFriendRequest (status) {
      if (this.submitting) {
        this.$message.error('Already submitting friend request, please wait!')
        return
      }

      this.submitting = true

      const res = await this.$http.put(`friendships/${this.userToPeak._id}/submit/${status}`)
      if (res.errors && res.errors.length) {
        ErrorHandling(res.errors, 'submitFriendship', { handleMessage: this.$message.error })
        this.submitting = false
      } else {
        this.submitting = false
        if (status === 'decline') {
          this.userToPeak.status = 'decline'
          this.$message.success('Friend request declined!')
        } else if (status === 'accept') {
          this.userToPeak.status = 'accepted'
          this.$message.success('Friend request accepted!')
        }
      }
    }
  }
}
</script>
<style lang="scss">
  @import '../styles/variables.scss';

  .peak-page {
    .el-divider__text {
      color: $main-color-2;
      background-color: transparent;
      font-size: $font-size-large;
    }

    .el-divider {
      background-color: transparent;
    }

    .el-form-item__label {
      color: #c6bfbf;
    }
  }
</style>
